import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import { visit } from "@hotwired/turbo"

export default class extends Controller {
  static values = { returnsUrl: String }

  connect() {
    this.modal = new Modal(this.element)
    this.modal.show()
  }

  startNewReturn() {
    this.modal.hide()

    this.element.addEventListener('hidden.bs.modal', () => {
      const searchModal = document.getElementById('assignmentSearchModal')
      if (!searchModal) return

      const bsSearchModal = new Modal(searchModal)
      bsSearchModal.show()

      searchModal.addEventListener('shown.bs.modal', () => {
        const cameraBtn = searchModal.querySelector('[data-barcode-scanner-target="cameraBtn"]')
        if (cameraBtn) cameraBtn.click()
      }, { once: true })
    }, { once: true })
  }

  decline() {
    visit(this.returnsUrlValue)
  }

  disconnect() {
    if (this.modal) this.modal.dispose()
  }
}
